// extracted by mini-css-extract-plugin
export var boxItems = "_a7-1";
export var boxItemsLg = "_a7-2";
export var button = "_a7-7";
export var buttonHoverless = "_a7-9";
export var buttonLg = "_a7-8";
export var filterGroupBox = "_a7-0";
export var icon = "_a7-3";
export var iconSecondary = "_a7-6";
export var iconWrapper = "_a7-4";
export var iconWrapperLg = "_a7-5";
export var truncatedLabel = "_a7-a";